import { ErrorListProps } from '@rjsf/utils';
import { AlertTriangle } from 'lucide-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@/ui/Alert';

const ErrorListTemplate = ({ errors }: Partial<ErrorListProps>) => {
	const { t } = useTranslation();

	useEffect(() => {
		if (errors?.length) {
			console.error('Form error', errors);
		}
	}, [errors]);

	return (
		<Alert variant="error" className="mt-6">
			<AlertTriangle />

			<div className="flex flex-col gap-2">
				<span>{t('v.fieldsInc')}</span>
				<span>{t('formDialog.repeatPlease')}</span>
			</div>
		</Alert>
	);
};

export { ErrorListTemplate };
